import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { xpcellService } from 'services';

import BarChartWithLegend from './DashboardPieWithLegend';

export const TechnicianDashboard = () => {
  const [orders, setOrders] = useState([]);

  const fetchData = async () => {
    try {
      const { data } = await xpcellService.getTechDashboard();
      setOrders(data);
    } catch (error) {
      toast.error('Ocorreu um erro ao consultar dados!');
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const tiposUnicos = [...new Set(orders.map((item) => item.trasf))];

  return (
    <div>
      <h2>Dashboard por Tipo</h2>
      {tiposUnicos.map((tipo) => {
        const dadosPorTipo = orders.filter((item) => item.trasf === tipo);
        return (
          <div key={tipo} style={{ marginBottom: '4rem' }}>
            <h3>{tipo}</h3>
            <BarChartWithLegend data={dadosPorTipo} chartTitle={tipo} />
          </div>
        );
      })}
    </div>
  );
};

export default TechnicianDashboard;
